export default "Med 5 små makkerpar yoga-øvelser kan I på en nem og god måde flytte fokus fra ”mig” til ”os”.\n\n**Denne aktivitet kan også laves ude.**\n";